import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Sientes que tu felicidad depende de ver un mensaje en tu pantalla.', 'Has bloqueado y desbloqueado a esa persona más de 5 veces este mes.', 'Te sientes humillado/a por haber rogado o pedido explicaciones sin éxito.', 'Quieres sanar de verdad, no solo "aguantar" el dolor.'];
  return <section className="py-24 relative bg-brand-darker border-y border-white/5 pt-[10px] pb-[10px]" data-id="element-11">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="max-w-2xl mx-auto" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-14">
            <h3 className="text-2xl font-bold text-brand-white mb-8 flex items-center gap-3" data-id="element-15">
              <span className="w-2 h-8 bg-brand-green rounded-full block" data-id="element-16" />
              ESTO ES PARA TI SI:
            </h3>
            <ul className="space-y-6" data-id="element-17">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-18">
                  <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0 mt-0.5" data-id="element-19" />
                  <span className="text-brand-gray text-lg" data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}